export default __webpack_public_path__ + "static/media/Claudio Mammana.3ff2aeef.jpeg";